import _ from '/home/ps/root'
import { combineReducers } from 'redux'
// import { routerReducer } from 'react-router-redux';
// import { connectRouter } from 'connected-react-router'
import { masterApp } from './master-app'
import { qApp } from './q-app'

export const createRootReducer = history => combineReducers({
  q: qApp,
  master: masterApp,
  // router: connectRouter(history)
})

export default createRootReducer
